<template>
  <div class="chat-message-container left">
    <div v-if="$store.state.config.storeId == 46" class="image-cropper" style="width: 42px; height: 42px; position: absolute; left: 0; bottom: 16px; overflow: hidden; border-radius: 50%; box-shadow: 0 0 1px 0 rgb(0 0 0), 0 1px 1px 0 rgb(0 0 0); background-color: white;">
      <img v-if="$store.state.config.storeId == 46" class="chat-avatar-noo" :src="this.admin_avatar" alt="Bot Avatar" />
    </div>
    <div v-if="$store.state.config.storeId == 49" class="image-cropper" style="width: 42px; height: 42px; position: absolute; left: 0; bottom: 16px; overflow: hidden; border-radius: 50%; box-shadow: 0 0 1px 0 rgb(0 0 0), 0 1px 1px 0 rgb(0 0 0); background-color: white;">
      <img v-if="$store.state.config.storeId == 49" class="chat-avatar-cleed" :src="this.admin_avatar" alt="Bot Avatar" />
    </div>
    <img v-if="$store.state.config.storeId != 46 && $store.state.config.storeId != 49" class="chat-avatar" :src="this.admin_avatar" alt="Bot Avatar" />
    <div class="chat-message">
      <typing-indicator />
    </div>
  </div>
</template>

<script>
import TypingIndicator from "./TypingIndicator";
import specs from "@/specs";
import utils from '../utils'

export default {
  name: "Chat",
  components: {
    TypingIndicator,
  },
  data: () => {
    return {
      admin_avatar: specs._ADMIN_IMG_AVATAR,
    };
  },
   mounted() {
    utils.scrollDown()
  },
};
</script>
